import React from 'react';
import i18next from 'i18next';
import moment from 'moment';
import { Button } from 'reactstrap';
import { MdDeleteOutline } from 'react-icons/md';
import { connect } from 'react-redux';
import { deleteVeranstaltung, fetchVeranstaltungOnly } from '../store/veranstaltungen/actions';
import { setScreenVeranstaltung } from '../store/appNavigation/actions';
import { showConfirmDialog } from '../store/confirmDialog/actions';
import { veranstaltungsChip } from './veranstaltungsZustand';

function VeranstaltungsItem(props) {
	moment().locale(i18next.language);
	const { data, countErfasste, removeVeranstaltung, goToVeranstaltung } = props;
	const chip = veranstaltungsChip(data, countErfasste);

	const endeZeit = moment(data.beginn).format('DD.MM.YYYY') !== moment(data.ende).format('DD.MM.YYYY')?
	moment(data.ende).format('DD.MM.YYYY HH:mm'):moment(data.ende).format('HH:mm')

	return (
		<div className="clickableValue container-fluid" title="Klicken Sie hier, um zur Punktemeldung zu gelangen"  onClick={ (e) => {goToVeranstaltung(data.vnr, data.bearer)}}>
			<div>{data.vnr}
				{chip.text && <span className={"ms-2 badge fw-normal " + chip.klasse}>{chip.text}</span>}
			</div>
			{/* Gedaempft heisst Titel, nicht ganze Karte: ein opacity-50 ueber alles naehme auch
			    den Knoepfen den Kontrast. Leiser wird das Lauteste, das es gefahrlos kann. */}
			<div className={"h5 mb-1" + (chip.gedaempft? " text-body-secondary":"")}>{data.thema}</div>
			<div>{data.unterthema}</div>
			<div className="row text-muted align-items-end">
				<div className="col">
					Kat. ({data.kategorie})&nbsp;
					{moment(data.beginn).format('DD.MM.YYYY HH:mm')} - {endeZeit}
				</div>
				{/* Die Aktionsspalte waechst mit statt fest zu sein: zwei Knoepfe passen nicht in
				    col-md-2, und auf schmalen Geraeten ruecken sie in eine eigene Zeile. */}
				<div className="col-12 col-sm-auto d-flex justify-content-end align-items-center gap-2 flex-wrap">
					{/* Die Hauptsache bekommt endlich ein sichtbares, per Tastatur erreichbares
					    Element - bisher war das Oeffnen nur ein onClick auf dem umgebenden div.
					    Die ganze Karte bleibt zusaetzlich klickbar (Touch). */}
					<Button onClick={(e) => {e.preventDefault(); e.stopPropagation(); goToVeranstaltung(data.vnr, data.bearer)}} size="sm"
						title="Zur Punktemeldung dieser Veranstaltung" color="info">Öffnen&nbsp;&rsaquo;</Button>
					{/* Gedaempft, nicht rot: Rot gehoert in den Bestaetigungsdialog, wo entschieden
					    wird, nicht auf die Karte, an der man vorbeiliest. */}
					<button type="button" className="btn btn-link btn-sm text-body-secondary text-decoration-none"
						onClick={(e) => {e.preventDefault(); e.stopPropagation(); removeVeranstaltung()}}
						title="Die Veranstaltung kann jederzeit wieder hinzugefügt werden">
						<MdDeleteOutline className="me-1" aria-hidden="true" />Entfernen</button>
			</div>
		</div>
	</div>);
}

export function countDistinctTeilnehmer(teilnahmeMeldungen){
	if(teilnahmeMeldungen===undefined) return 0
	const punkteMeldungen = Object.values(teilnahmeMeldungen)
	const distinctEFNs = {}
	punkteMeldungen.map((item) => { distinctEFNs[item.efn] = 1; return item })
	return Object.keys(distinctEFNs).length

}

const mapStateToProps = (state, ownProps) => {
	const teilnahmeMeldungen = state.punkteMeldung.teilnahmeMeldungen[ownProps.data.vnr]
	return {
		gemeldeteTeilnehmer: countDistinctTeilnehmer(teilnahmeMeldungen)
	}

}
const mapDispatchToProp = (dispatch, ownProps) => ({
	removeVeranstaltung: () => {
		if( ownProps.countErfasste > 0){
			dispatch(showConfirmDialog(
				"Veranstaltung entfernen", 
				`Es gibt ${ownProps.countErfasste} erfasste und noch nicht gemeldete Teilnehmer. Diese Daten gehen dabei verloren. Trotzdem entfernen?`,
				(e) => dispatch(deleteVeranstaltung(ownProps.data.vnr)),
				"Entfernen" ))
		}else{
			dispatch(deleteVeranstaltung(ownProps.data.vnr))
		}
	},
	goToVeranstaltung : (vnr, bearer) => {
		dispatch(fetchVeranstaltungOnly(bearer))
		dispatch(setScreenVeranstaltung(vnr))
	}
})

export default connect(mapStateToProps, mapDispatchToProp)(VeranstaltungsItem)